import { createContext, Dispatch } from 'react'
import { GlobalActions, GlobalActionTypes } from './types'


export interface GlobalState {
    isIssuingCard: boolean
    isServicable: boolean
    isUpdateAvailable: {
        isAvailable: boolean
        isCritical: boolean
    }
    shouldIgnoreUpdateAvailable: boolean
    showParticipantJoinedModal: boolean
}

export const initState: GlobalState = {
    isIssuingCard: false,
    isServicable: true,
    isUpdateAvailable: {
        isAvailable: false,
        isCritical: false
    },
    shouldIgnoreUpdateAvailable: false,
    showParticipantJoinedModal: false
}

export function GlobalReducer(state = initState, action: GlobalActionTypes): GlobalState {
    switch (action.type) {
        case GlobalActions.SET_IS_ISSUING_CARD: return { ...state, isIssuingCard: action.payload }
        case GlobalActions.SET_IS_SERVICABLE: return { ...state, isServicable: action.payload }
        case GlobalActions.SET_IS_UPDATE_AVAILABLE: return { ...state, isUpdateAvailable: action.payload }
        case GlobalActions.SET_SHOULD_IGNORE_AVAILABLE_UPDATE: return { ...state, shouldIgnoreUpdateAvailable: action.payload }
        case GlobalActions.SET_SHOW_PARTICIPANT_JOINED_MODAL: return { ...state, showParticipantJoinedModal: action.payload }
        default: return state
    }
}

export const GlobalContext = createContext<{ localState: GlobalState, localDispatch: Dispatch<GlobalActionTypes> }>({
    localState: initState,
    localDispatch: () => undefined,
})
